import { Auth as RealAuth, API as RealAPI, Amplify } from "aws-amplify";
import config from "./config";
import MockAuth from "./mock/MockAuth";
import MockAPI from "./mock/MockAPI";

function realConfigure() {
  Amplify.configure({
    Auth: {
      mandatorySignIn: true,
      region: config.cognito.REGION,
      userPoolId: config.cognito.USER_POOL_ID,
      identityPoolId: config.cognito.IDENTITY_POOL_ID,
      userPoolWebClientId: config.cognito.APP_CLIENT_ID,
    },
    API: {
      endpoints: [
        {
          name: "rugged-brain-api",
          endpoint: config.apiGateway.URL,
          region: config.apiGateway.REGION,
        },
      ],
    },
  });
}

const mockConfigure = () => {};

const isE2E = window.location.href.indexOf("e2e=1") > -1;
export const Auth = isE2E ? MockAuth : RealAuth;
export const API = isE2E ? MockAPI : RealAPI;
export const configure = isE2E ? mockConfigure : realConfigure;
